import moment from 'moment';
import * as parsedDetailsTypes from './parsedDetailsTypes';

const formatDate = (dateString) => moment.utc(dateString).format('ll');

export default {
  [parsedDetailsTypes.NAME]: {
    icon: 'small-user-single',
    title: 'Name',
    format: ({ raw }) => raw,
    show: ({ confidence }) => confidence > 0.9,
  },
  [parsedDetailsTypes.ADDRESS]: {
    icon: 'small-travel-map-location-pin',
    title: 'Address',
    format: ({ normalized }) => normalized,
    show: ({ confidence, normalized }) => confidence > 0.7 && !!normalized,
  },
  [parsedDetailsTypes.COMPANY]: {
    icon: 'small-shopping-store-2',
    title: 'Company',
    format: ({ name }) => name,
  },
  [parsedDetailsTypes.DOCUMENT_DATE]: {
    icon: 'small-calendar-date',
    title: 'Document Date',
    format: ({ normalized }) => formatDate(normalized),
    show: () => true,
  },
  [parsedDetailsTypes.ACCOUNT_NUMBER]: {
    icon: 'small-money-atm-card-1',
    title: 'Account Number',
  },
  [parsedDetailsTypes.BEGINNING_BALANCE]: {
    icon: 'small-money-cash-coins-stack',
    title: 'Beginning Balance',
    format: ({ formatted }) =>
      formatted.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
  },
  [parsedDetailsTypes.ENDING_BALANCE]: {
    icon: 'small-money-cash-coins-stack',
    title: 'Ending Balance',
    format: ({ formatted }) =>
      formatted.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
  },
  [parsedDetailsTypes.DATE_OF_BIRTH]: {
    icon: 'small-calendar-date',
    title: 'Date of Birth',
    format: ({ formatted }) => formatDate(formatted),
  },
  [parsedDetailsTypes.EXPIRY_DATE]: {
    icon: 'small-calendar-date',
    title: 'Expiry Date',
    format: ({ formatted }) => formatDate(formatted),
  },
  [parsedDetailsTypes.EIN]: {
    icon: 'small-id-thumb-mark',
    title: 'EIN',
    multi: true,
    format: ({ normalized }) => normalized,
  },
  [parsedDetailsTypes.SSN]: {
    icon: 'small-id-thumb-mark',
    title: 'SSN',
    multi: true,
    format: ({ normalized }) => normalized,
  },
};
